import { Provider } from "react-redux";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";
import { ChakraProvider } from "@chakra-ui/react";
import { store, persistor } from "./redux/store";
import { theme } from "./theme";
import { PersistGate } from "redux-persist/integration/react";
import './i18n/config';
import { LayoutDirectionProvider } from "./providers/layoutDirectionProvider";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { SidebarProvider } from "./Components/Common/SidebarPlugin/SidebarContext";
import { registerAiSidebar } from "./Components/Pages/Main/Ai";

registerAiSidebar();

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ChakraProvider theme={theme}>
            <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
              <LayoutDirectionProvider>
                <SidebarProvider>
                  <App />
                </SidebarProvider>
              </LayoutDirectionProvider>
            </GoogleOAuthProvider>
        </ChakraProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then(function (registration) {
      console.log("Registration successful, scope is:", registration.scope);
    })
    .catch(function (err) {
      console.log("Service worker registration failed, error:", err);
    });
}
// serviceWorker.register();
reportWebVitals();
